import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

export interface SentryUser {
	id?: string;
	email?: string;
	username?: string;
	[key: string]: any;
}

export interface SentryBreadcrumb {
	message: string;
	category?: string;
	level?: Sentry.SeverityLevel;
	data?: Record<string, any>;
}

export interface SentryContext {
	tags?: Record<string, string>;
	extra?: Record<string, any>;
	contexts?: Record<string, any>;
}

@Injectable({
	providedIn: 'root',
})
export class SentryService {
	constructor() {}

	/**
	 * Manually capture an exception and send it to Sentry
	 * @param error - The error to capture
	 * @param context - Additional context (tags, extra data, contexts)
	 */
	captureException(
		error: Error,
		showReport: boolean = false,
		context?: SentryContext
	): string {
		if (context) {
			Sentry.withScope((scope) => {
				if (context.tags) {
					Object.entries(context.tags).forEach(([key, value]) => {
						scope.setTag(key, value);
					});
				}

				if (context.extra) {
					Object.entries(context.extra).forEach(([key, value]) => {
						scope.setExtra(key, value);
					});
				}

				if (context.contexts) {
					Object.entries(context.contexts).forEach(([key, value]) => {
						scope.setContext(key, value);
					});
				}
			});
		}
		const eventId = Sentry.captureException(error);
		if (showReport) {
			Sentry.showReportDialog({
				eventId: eventId,
			});
		}
		return eventId;
	}

	/**
	 * Show user feedback dialog (if enabled in Sentry config)
	 * @param eventId - Event ID from captured error
	 */
	showReportDialog(eventId?: string): void {
		Sentry.showReportDialog({
			eventId: eventId,
		});
	}
}
